import {raf} from "./raf";

// Helper function to convert RGB values to hex code
function rgbToHex(r, g, b) {
    return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
}

async function heroImageRatio(img) {
    return new Promise((resolve, reject) => {
        const onLoad = () => {
            resolve(img.naturalHeight / img.naturalWidth);
        };

        if (img.complete) {
            onLoad();
            return;
        } else {
            img.onload = onLoad;
        }
    });
}

async function heroImageColor(img) {
    return new Promise((resolve, reject) => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        const canvasImage = new Image();
        canvasImage.crossOrigin = 'Anonymous';

        canvasImage.onload = () => {
            ctx.drawImage(canvasImage, 0, 0);

            // Get the pixel data of the top-left corner (position: 0,0)
            // TODO: get other pixels too? average?
            const pixelData = ctx.getImageData(0, 0, 1, 1).data;
            const [red, green, blue] = pixelData;

            // const otherPixel = ctx.getImageData(canvasImage.width - 1, canvasImage.height - 1, 1, 1).data

            resolve(rgbToHex(red, green, blue));
        };

        canvasImage.onerror = reject;
        canvasImage.src = img.src;
    });
}

export default function heroImage() {
    document.querySelectorAll('.gh-feature-image img').forEach(async (img) => {
        const parent = img.closest('.gh-header');
        if (parent) {
            const color = await heroImageColor(img);
            const aspectRatio = await heroImageRatio(img);

            parent.style.setProperty('--hero-image-height', `${img.clientWidth * aspectRatio}px`);
            parent.style.setProperty('--hero-image-color', color);

            parent.classList.add('gh-header-has-feature-image');
            document.body.classList.add('gh-has-feature-image');

            const observer = new ResizeObserver((entries) => {
                raf(() => {
                    const {inlineSize} = entries[0].contentBoxSize[0];
                    parent.style.setProperty('--hero-image-height', `${inlineSize * aspectRatio}px`);
                });
            });
            observer.observe(img.closest('.gh-feature-image'));
        }
    });
}
